import { render, staticRenderFns } from "./DeliveryWaiting.vue?vue&type=template&id=34214e41"
import script from "./DeliveryWaiting.vue?vue&type=script&lang=js"
export * from "./DeliveryWaiting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports